<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    xValue: { type: Array, default: null },
    yValue: { type: Array, default: null },
  },
  data: () => ({
    time: [],
    time2: [],
    dataSet: [],
    dataSet2: [],
    resultIndoorManHour: [],
    resultIndoorTagManHour: [],
    selectLoop: 1,
  }),
  updated() {
    console.log("update data chart ");
  },
  computed: {
    xV:function() {
      return this.xValue;
    },

    yV:function() {
      return this.yValue;
    },
  },
  mounted() {
    console.log("chart", this.xV, this.yV);
    this.renderBarChart();
  },
  methods: {
    renderBarChart: function () {
      this.renderChart(
        {
          labels: this.xV,
          datasets: [
            {
              label: "Total Worker",
              backgroundColor: "#4caf50",
              data: this.yV,
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                ticks: {
                  stepSize: 1,
                  min: 0,
                  // max: 100,
                },
              },
            ],
          },
        }
      );
    },
  },
  watch: {
    xValue: function() {
      // this._chart.destroy();
      //this.renderChart(this.data, this.options);
      this.renderBarChart();
    }
  }
};
</script>
